import React, { useState, useRef, useEffect } from 'react';
import { speakWithPolly } from '../utils/pollyService';

function CountDown({ mode, onStart, darkMode }) {
  const [countdown, setCountdown] = useState(5);
  const [emoji, setEmoji] = useState('🐶');
  
  const emojis = ['🐶','🐱','🐰','🐻','🦊','🐼','🐨','🐸','🐯','🐷'];
  
  const isRunningRef = useRef(false);
  const intervalRef = useRef(null); // 🔧 interval 참조 추가
  const isInitializedRef = useRef(false); // 🔧 초기화 여부 확인
  
  const cardClass = darkMode 
    ? 'bg-gray-800 text-white' 
    : 'bg-white text-gray-800';

  // 🔧 간단한 함수들 (useCallback 제거)
  const randomEmoji = () => {
    return emojis[Math.floor(Math.random() * emojis.length)];
  };

  // 🔧 메시지를 단순화 - 로컬 음성 파일과 일치하도록
  const getMessage = () => {
    // 모든 모드에서 동일한 메시지 사용 (countdown.mp3 파일과 일치)
    return '잠시후 모의면접이 시작됩니다';
  };

  // 🔧 정리 함수
  const cleanup = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    isRunningRef.current = false;
  };

  const startCountdown = () => {
    // 🔧 이미 실행 중이면 중단
    if (isRunningRef.current || isInitializedRef.current) {
      console.log('⚠️ 카운트다운 이미 실행 중 또는 초기화됨');
      return;
    }

    console.log('🎯 카운트다운 시작!');
    isRunningRef.current = true;
    isInitializedRef.current = true;
    
    // 🎵 로컬 음성 재생 - countdown.mp3 파일이 자동으로 재생됨
    const message = getMessage();
    speakWithPolly(message, () => {
      console.log('🎵 카운트다운 음성 완료 (로컬 파일)');
    });

    // 카운트다운 시작
    let count = 5;
    setCountdown(count);
    setEmoji(randomEmoji());

    intervalRef.current = setInterval(() => {
      count--;
      console.log(`⏰ 카운트다운: ${count}`);
      setCountdown(count);
      setEmoji(randomEmoji());
      
      if (count === 0) {
        console.log('🏁 카운트다운 완료!');
        cleanup();
        setTimeout(() => {
          onStart();
        }, 1000);
      }
    }, 1000);
  };

  // 🔧 useEffect 단순화 (의존성 배열 비우기)
  useEffect(() => {
    // 컴포넌트 마운트 시 한 번만 실행
    const timer = setTimeout(() => {
      startCountdown();
    }, 300);

    // 정리 함수
    return () => {
      clearTimeout(timer);
      cleanup();
      isInitializedRef.current = false;
    };
  }, []); // 🔧 빈 의존성 배열로 한 번만 실행

  // 🔧 컴포넌트 언마운트 시 정리
  useEffect(() => {
    return () => {
      cleanup();
      isInitializedRef.current = false;
    };
  }, []);

  return (
    <div className="text-center text-3xl font-bold animate-pulse">
      <div className={`p-8 rounded-2xl ${cardClass} shadow-2xl`}>
        <p className="mb-6 text-2xl md:text-3xl">
          ⏳ {countdown}초후 모의면접이 시작됩니다!
        </p>
        <div className="text-8xl mb-4 animate-bounce">{emoji}</div>
        <div className={`text-lg mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {mode === 'default' && '📝 기본질문 면접'}
          {mode === 'deep' && '📚 심화질문 면접'}
          {mode === 'situation' && '🎯 상황별 면접'}
          {mode === 'custom' && '💼 직무별 면접'}
          {mode === 'admission' && '🎓 입시면접'} 
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-4">
          <div 
            className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full transition-all duration-1000"
            style={{ width: `${((5 - countdown) / 5) * 100}%` }}
          ></div>
        </div>
        <div className="text-xs mt-2 opacity-75 text-green-500">
          🔊 완전한 로컬 음성 시스템 사용중
        </div>
        
        {/* 🔧 디버깅 정보 (개발 시에만 표시) */}
        {process.env.NODE_ENV === 'development' && (
          <div className="text-xs mt-1 opacity-50">
            실행상태: {isRunningRef.current ? '실행중' : '대기중'} | 
            초기화: {isInitializedRef.current ? 'Yes' : 'No'}
          </div>
        )}
      </div>
    </div>
  );
}

export default CountDown;